'use strict';

export default function StickyContainer({
    isStickable = true,
    wrapClassName = 'sticky-wrapp',
    containerClassName = 'sticky',
    containerStickyClassName = 'is-sticky',
    offsetTop = 0,
    stickyPadding = 0,
    onChange,
    children})
{
    const wrapRef = React.useRef();
    const containerRef = React.useRef();
    const [isSticky, setIsSticky] = React.useState(false);
    const [fixedHeight, setFixedHeight] = React.useState(null);

    // Актуальное значение для колбэков вне рендера (ресайз-обсервер, скролл).
    const isStickyRef = React.useRef(isSticky);
    isStickyRef.current = isSticky;

    React.useEffect(() => {
        
        if (!isStickable) {
            setFixedHeight(null);
            setIsSticky(false);
        }

        if (isStickable && containerRef.current) {

            const $wrap = $(wrapRef.current)
            const $container = $(containerRef.current);
            
            let wrapTop = $wrap.offset().top - stickyPadding;

            function snapshot() {
                return {
                    wrapHeight: $wrap.outerHeight() || 0,
                    containerHeight: $container.outerHeight() || 0,
                };
            }

            // Плейсхолдер (wrap) при залипании должен повторять живую высоту
            // контента, иначе врап и контейнер разъезжаются.
            function notify(stuck) {
                const { wrapHeight, containerHeight } = snapshot();
                if (stuck) {
                    setFixedHeight(containerHeight);
                    onChange && onChange({ isSticky: true, stickyTop: wrapTop, wrapHeight: containerHeight, containerHeight });
                } else {
                    onChange && onChange({ isSticky: false, stickyTop: wrapTop, wrapHeight, containerHeight });
                }
            }

            function handleWindowLoad() {
                wrapTop = $wrap.offset().top - stickyPadding;
                handleWindowScroll()
            }
            function handleWindowScroll() {
                const scrollTop = $(this).scrollTop();
                if (scrollTop + offsetTop >= wrapTop && !isSticky) {
                    setIsSticky(true);
                    notify(true);
                }
                if (scrollTop + offsetTop < wrapTop && isSticky) {
                    setIsSticky(false);
                    notify(false);
                }
            }

            // Контент подгружается динамически: размеры могут меняться без
            // скролла и переходов — следим и докладываем родителю свежие.
            const resizeObserver = new ResizeObserver(() => {
                notify(isStickyRef.current);
            });
            resizeObserver.observe(containerRef.current);

            $(window).on('scroll', handleWindowScroll);
            $(window).on('load', handleWindowLoad);
            
            handleWindowScroll.call(window)

            return () => {
                resizeObserver.disconnect();
                $(window).off('scroll', handleWindowScroll);
                $(window).off('load', handleWindowLoad);
            }
        }
    }, [isStickable, setIsSticky, isSticky, offsetTop]);
    
    return <div ref={wrapRef} className={wrapClassName} style={{
        height: isSticky ? fixedHeight : undefined,
    }}>
        <div ref={containerRef} 
             className={cn(containerClassName, isSticky && containerStickyClassName)} 
             style={{
                 top: isSticky ? offsetTop : undefined,
                 maxHeight: window.innerHeight - offsetTop - stickyPadding * 2
             }}>
            {children}
        </div>
    </div>
}